var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},[_c('div',{staticClass:"select-checked"},[_c('span',[_vm._v("已选择")]),_c('span',{staticClass:"select-checked-num"},[_vm._v(_vm._s(_vm.num))]),_c('span',[_vm._v("个"+_vm._s(_vm.text))])]),_c('div',[_c('bi-button',{attrs:{"type":"blueText"},on:{"click":_vm.choose}},[_vm._v("选择"+_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }